<template>
    <div class="main">

        <el-row :gutter="10" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
            <el-col :xs="24" :sm="6" :md="6">
                <div class="level">
                    <div class="icone">
                        <img src="/public/img/salas.png" />
                    </div>
                    <div class="info">
                        <div class="titulo-card">Total de Instituições</div>
                        <div v-if="statusList" class="valor-card">{{ resumo.total }}</div>
                        <div v-else>
                            <div class="valor-card">
                                <img src="/public/img/loading-bar.gif">
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
                <div class="level">
                    <div class="icone">
                       <img src="/public/img/file.png" />
                    </div>
                    <div class="info">
                        <div class="titulo-card">Arquivos Gerados</div>
                        <div v-if="statusList" class="valor-card">{{ resumo.total - resumo.pendentes }}</div>
                        <div v-else>
                            <div class="valor-card">
                                <img src="/public/img/loading-bar.gif">
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
                <div class="level">
                    <div class="icone">
                        <img src="/public/img/stop.png" />
                    </div>
                    <div class="info">
                        <div class="titulo-card">Pendentes</div>
                        <div v-if="statusList" class="valor-card">{{ resumo.pendentes }}</div>
                        <div v-else>
                            <div class="valor-card">
                                <img src="/public/img/loading-bar.gif">
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
                <div class="level">
                    <div class="icone">
                        <img src="/public/img/checked.png" />
                    </div>
                    <div class="info">
                        <template v-if="statusList">
                        <div class="titulo-card">Migrado <span style="width: 50px;">{{ resumo.migrado }}</span></div>
                        <div class="titulo-card"><b>Fechado</b> <span>{{ resumo.fechado }}</span></div>
                        </template>
                        <div v-else>
                            <div class="valor-card">
                                <img src="/public/img/loading-bar.gif">
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-tabs type="border-card" v-model="tabAtiva">

            <el-tab-pane label="MIGRAÇÃO" name="0">
                <template v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                    <el-form class="u-mt-10 u-mb-20">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Instituição" prop="instituicao" key="instituicao">
                                    <el-input v-model="filtro.instituicao" placeholder="Pesquisar instituicao..." @keyup.native.enter="changeInstituicao()"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12" class="u-text-right">
                                <el-form-item label="Status da Migração" prop="status" key="status">
                                    <el-select @change="changeFilters()" size="small" v-model="filtro.status" clearable>
                                        <el-option v-for="(item, i) in $CONSTANTS.STATUS_EDUCACENSO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </template>
                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="hidden-mobile" style="width: 70px;">cod</th>
                                <th>Nome</th>
                                <th style="width: 200px;" class="hidden-mobile u-text-center">Status da Migração</th>
                                <th class="u-text-center" style="width: 130px;">Ação</th>
                            </tr>
                        </thead>
                        <tbody v-if="statusList">
                            <tr v-for="item in items" :key="item.id">
                                <td class="hidden-mobile">{{ item.id }}</td>
                                <td>{{ item.nome }}</td>
                                <td v-bind:style="{ backgroundColor: getColorStatus(item.status_etapa_final_educacenso) }" class="hidden-mobile u-text-center">
                                    <!--
                                        12 - ADEVALDO SILVA FREITAS JUNIOR
                                         3 - SMED
                                       184 - ALDA CLERIA OLIVEIRA DA SILVA
                                       262 - LUCIANO ALMEIDA SANTOS
                                       220 - CRISTIANNE RIBEIRO DOS SANTOS SILVA
                                       234 - MARIA NELIA BRITO PEREIRA
                                       239 - JOSE ADELMO SILVA JUNIOR
                                       468 - EDINALDO LIMA OLIVEIRA
                                    -->
                                    <el-select :disabled="$store.state.user.id != 12 && 
                                                $store.state.user.id != 3 && $store.state.user.id != 184 && 
                                                $store.state.user.id != 262 && $store.state.user.id != 220 && 
                                                $store.state.user.id != 234 && $store.state.user.id != 239 &&
                                                $store.state.user.id != 468" v-model="item.status_etapa_final_educacenso" @change="changeStatus(item.id, item.status_etapa_final_educacenso)" class="sel-edc" size="small"
                                    v-bind:class="{
                                        educacensoPendente: (item.status_etapa_final_educacenso == 1 ? true : false),
                                        educacensoGerado: (item.status_etapa_final_educacenso == 2 ? true : false),
                                        educacensoValidado: (item.status_etapa_final_educacenso == 3 ? true : false),
                                        educacensoMigrado: (item.status_etapa_final_educacenso == 4 ? true : false),
                                        educacensoFechado: (item.status_etapa_final_educacenso == 5 ? true : false) }">
                                        <el-option v-for="(item, i) in $CONSTANTS.STATUS_EDUCACENSO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </td>
                                <td class="u-text-center acao">

                                    <a v-if="item.validacao_etapa_final_educacenso && item.status_etapa_final_educacenso == 4" href="javascript:void(0)" class="u-mr-10">
                                        <i class="far fa-file-alt i-censo download"></i>
                                    </a>


                                    <a v-if="item.validacao_etapa_final_educacenso && item.file_etapa_final_educacenso && item.status_etapa_final_educacenso != 1" :href="$store.state.config.baseUrlApi + '/' + item.relatorio_etapa_final_educacenso" class="u-mr-10" target="_blank" download="file.txt">
                                        <i class="far fa-file-alt i-censo success"></i>
                                    </a>

                                    <a v-if="item.validacao_etapa_final_educacenso && item.file_etapa_final_educacenso && item.status_etapa_final_educacenso != 1 && $store.state.user.tipo > 3" :href="$store.state.config.baseUrlApi + '/' + item.file_etapa_final_educacenso" class="u-mr-10" target="_blank" download="file.txt">
                                        <i class="fas fa-check-circle i-censo success"></i>
                                    </a>

                                    <a v-if="!item.validacao_etapa_final_educacenso && item.file_etapa_final_educacenso" :href="$store.state.config.baseUrlApi + '/' + item.file_etapa_final_educacenso" class="u-mr-10" target="_blank" download="file.txt">
                                        <i class="fas fa-exclamation-triangle i-censo alert"></i>
                                    </a>

                                    <a v-if="item.status_inep_import" href="javascript:void(0)">
                                        <i @click="gerarArquivo(item.id, item.status_etapa_final_educacenso)" class="fas fa-sync-alt i-censo reprocess"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!statusList" class="u-text-center u-mt-25">
                        <img src="/public/img/loading-bar.gif" />
                    </div>
                    <el-row :gutter="10" v-if="statusList">
                        <el-col :xs="24" :sm="12" :md="12">
                            <div class="u-text-left u-mt-10">
                                Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                            <div class="u-text-right">
                                    <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                                </div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>
<script>

export default {
    data: () => ({
        loadingArquivo: false,
        urlApi: process.env.VUE_APP_BASE_URL,
        tabAtiva: 0,
        loadingSearchInst: false,
        statusList: false,
        filtro: {
            instituicao: '',
            situacao_funcionamento: 1,
            status: '',
            instituicao_id: '',
            etapa: 2
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        instituicoes: [],
        items: [ ],
        resumo: {
            total: null,
            pendentes: null,
            total: null
        }
    }),
    mounted () {

        if([0, 1, 12].includes(Number(this.$store.state.user.tipo)) && this.$store.state.config.instituicao && this.$store.state.config.instituicao.id){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.loadingInstituicoes()
    },
    methods: {
        gerarArquivo(id, status){

            if(status == 4){

                window.eventBus.$emit('alert', {msg: 'Instituição com o status de MIGRADO não pode mais ter o seu arquivo processado.', type: 'warning'});
                return false;
            }

            this.$msgbox.confirm('Tem certeza que deseja gerar o arquivo da instituição selecionada?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                this.loadingArquivo = true;

                window.eventBus.$emit('loading', true);

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/educacenso/etapa-final/processa-arquivo/` + id, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingInstituicoes();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{ this.loadingInstituicoes(); });

        },
        changeStatus(id, status_etapa_final_educacenso){

            this.$msgbox.confirm('Tem certeza que deseja alterar o status de migração desta instituição?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/updateStatusFinalEducacenso/${id}`, { status : status_etapa_final_educacenso }, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingInstituicoes();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{ this.loadingInstituicoes(); });

        },
        getColorStatus(status){

            switch (status) {
                case 1: return '#ffa4a4'; 
                case 2: return '#fff4a4'; 
                case 3: return '#70bad0'; 
                case 4: return '#9ee08d'; 
                case 5: return '#70bad0'; 
            }
        },
        changeInstituicao(){

            this.filtro.situacao_funcionamento = '';
            this.filtro.status = '';

            this.loadingInstituicoes();
        },
        changeFilters(){

            this.filtro.instituicao = '';

            this.loadingInstituicoes();
        },
        loadingInstituicoes(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAllForEducacenso?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.itens.data;
                this.resumo = response.data.resumo;
                this.paginate.qtdItens = response.data.itens.total;
                this.paginate.from = response.data.itens.from;
                this.paginate.to = response.data.itens.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingInstituicoes();
        }
    },
    components:{  }
}
</script>